<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>가입내역</h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="">단말기모델명</label>
            </dt>
            <dd class="field-control">
              <select class="input-width-large" v-model="retrieveData.trmMdlCd">
                <option value="">선택하세요</option>
                <option
                  v-for="item in deviceList"
                  :value="item.trmMdlCd"
                  :key="item.trmMdlCd"
                  >{{ item.trmMdlNm }}</option
                >
              </select>
            </dd>
          </dl>

          <!--- 신규일 때  -->
          <template v-if="payYn === 'N'">
            <dl class="field-group">
              <dt class="field-label">
                <label for="">단말기일련번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <input
                    type="text"
                    @input="onlyText"
                    name="itemSn"
                    autocomplete="off"
                    v-model="retrieveData.itemSn"
                    class="input-width-large input-text input-font"
                    placeholder="단말기 일련번호 입력"
                    title="단말기 일련번호"
                  />
                </div>
              </dd>
            </dl>

            <dl class="field-group" v-show="this.entrLoc == ''">
              <dt class="field-label">
                <label for="">개통국번</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="retrieveData.ctn"
                    type="text"
                    @input="onlyText"
                    name="ctn"
                    autocomplete="off"
                    class="input-width-large input-text input-font"
                    placeholder="개통국번 입력"
                    title="개통국번"
                  />
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="">유심모델명</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="retrieveData.usimMdlNm"
                    type="text"
                    @input="onlyText"
                    name="usimMdlNm"
                    autocomplete="off"
                    class="input-width-large input-text input-font"
                    placeholder="유심모델명 입력"
                    title="유심모델명"
                  />
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="">유심일련번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="retrieveData.usimSn"
                    type="text"
                    @input="onlyText"
                    name="usimSn"
                    autocomplete="off"
                    class="input-width-large input-text input-font"
                    placeholder="유심 일련번호 입력"
                    title="유심일련번호"
                  />
                </div>
              </dd>
            </dl>

            <dl class="field-group" v-show="(this.imei+'').length < 1 && this.entrLoc == ''">
              <dt class="field-label">
                <label for="">네비게이션 일련번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="retrieveData.naviSn"
                    type="text"
                    @input="onlyText"
                    name="naviSn"
                    autocomplete="off"
                    class="input-width-large input-text input-font"
                    placeholder="네비게이션 일련번호 입력"
                    title="네비게이션 일련번호"
                  />
                </div>
              </dd>
            </dl>
          </template>

          <!--- 중고 일 때  -->
          <template v-if="payYn === 'Y'">
            <dl class="field-group">
              <dt class="field-label">
                <label for="">단말기일련번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ retrieveData.itemSn }}
                  </p>
                </div>
              </dd>
            </dl>

            <dl class="field-group" v-show="(this.imei+'').length < 1 && this.entrLoc == ''">
              <dt class="field-label">
                <label for="">희망번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <span class="input-sub-text">010-****-</span>
                  <input
                    v-model="retrieveData.chgHopTlno"
                    type="text"
                    @input="onlyNumber"
                    maxlength="4"
                    autocomplete="off"
                    name="chgHopTlno"
                    class="input-text input-font input-width-xsmall mw60"
                    placeholder="예) 1234"
                    title="희망번호 맨 뒤 네자리 숫자 입력"
                  />
                </div>
                <ul class="notice-text-list">
                  <li class="notice-text">
                    희망번호 뒤 4자리를 입력해 주세요.
                  </li>
                </ul>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="">요금제</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ retrieveData.phonePayStyle }}
                  </p>
                </div>
              </dd>
            </dl>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commCode } from '@/api/common'
export default {
  name: 'ConnectedCarDeviceSection',
  props: {},
  data() {
    return {
      payYn: '',
      deviceList: [],
      retrieveData: {
        itemSn: '', // 단말기 일련번호
        trmMdlCd: '', // 디바이스 일련 코드
        trmMdlNm: '',
        chgHopTlno: '', // 희망번호
        dealCd: '', // 대리점 코드
        entrRqstFomNo: '', // 폼 아이디
        usimMdlNm: '', // 유심모델명
        usimSn: '', // 유심일련번호
        naviSn: '', // 네비게이션일련번호
        phonePayStyle: '', // 요금제명
        phonePayStyleCd: '',
        ctn: '', //개통국번
        imei: '', //도요타 시리얼번호
        entrLoc: ''
      }
    }
  },
  created() {},
  mounted() {
    this.payYn = this.$store.state.connectedCar.common.payYn
    this.retrieveData.dealCd = this.$store.state.connectedCar.common.dealCd
    this.retrieveData.entrRqstFomNo = this.$store.state.connectedCar.common.appfFomNo
    this.retrieveData.trmMdlCd = this.$store.state.connectedCar.common.trmMdlCd
    this.retrieveData.trmMdlNm = this.$store.state.connectedCar.common.trmMdlNm
    this.retrieveData.usimMdlNm = this.$store.state.connectedCar.common.usimMdlNm
    this.retrieveData.usimSn = this.$store.state.connectedCar.common.usimSn
    this.retrieveData.naviSn = this.$store.state.connectedCar.common.naviSn
    this.retrieveData.phonePayStyle = this.$store.state.connectedCar.common.phonePayStyle
    this.retrieveData.phonePayStyleCd = this.$store.state.connectedCar.common.phonePayStyleCd
    this.retrieveData.itemSn = this.$store.state.connectedCar.common.itemSn
    this.retrieveData.ctn = this.$store.state.connectedCar.common.ctn
    this.deviceList = this.$store.state.connectedCar.common.deviceList
    this.imei = this.$store.state.connectedCar.common.imei
    this.entrLoc = this.$store.state.connectedCar.common.entrLoc
  },
  computed: {},
  methods: {
    /** 
     * Function    : validDevice
     * Description : 가입내역 필수값 Validation
     **/
    validDevice() {
      let title = '가입내역'
      if (!this.retrieveData.trmMdlCd) {
        this.openAlert(title, '단말기모델명을 입력하세요')
        return false
      }
      if (this.payYn === 'N') {
        // 신규일 때
        if (!this.retrieveData.itemSn) {
          this.openAlert(title, '단말기일련번호를 입력하세요')
          return false
        }
        if (!this.retrieveData.usimMdlNm) {
          this.openAlert(title, '유심모델명을 입력하세요')
          return false
        }
        if (!this.retrieveData.usimSn) {
          this.openAlert(title, '유심일련번호를 입력하세요')
          return false
        }
        if((this.imei+"").length < 1 && this.entrLoc == '') {
          if (!this.retrieveData.naviSn) {
            this.openAlert(title, '네비게이션 일련번호을 입력하세요')
            return false
          }
        }
      }

      if (this.payYn === 'Y') {
        // 중고 일 때
        if (!this.retrieveData.itemSn) {
          this.openAlert(title, '단말기일련번호를 입력하세요')
          return false
        }
        if (!this.retrieveData.chgHopTlno && (this.imei+"").length < 1 && this.entrLoc == '') {
          this.openAlert(title, '희망번호를 입력하세요')
          return false
        }
        // if (!this.retrieveData.phonePayStyle) {
        //   this.openAlert(title, '요금제를 입력하세요')
        //   return false
        // }
      }

      return true
    },

    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      this.retrieveData[e.target.name] = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },
    
    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      this.retrieveData[e.target.name] = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    }
  }
}
</script>

<style scoped></style>
